import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '../_models';
import { UsersAndGroupsService } from './users-and-groups.service';
import { AlertService } from './alert.service';
import { AppConfig } from 'src/assets/config/config/app-config';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    public currentUserSubject: BehaviorSubject<any>;

    public currentUser: Observable<User>;

    public userGroupsSubject: BehaviorSubject<any>;

    public userGroups: Observable<string[]>;

    public isAdminSubject: BehaviorSubject<any>;

    public isAdmin: Observable<boolean>;    

    public ongoingAPIRequestSubject: BehaviorSubject<any>;

    private ongoingRequestList: string[] = [];

    // isDjangoAuth: boolean = (`${environment.isDjangoAuth}` == "true")

    constructor(
        private http: HttpClient,
        private userGroupService: UsersAndGroupsService,
        private alertService: AlertService,
        private config: AppConfig,
        private usersGroupsService: UsersAndGroupsService
    ) {
        this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this.userGroupsSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('userGroups')));
        this.userGroups = this.userGroupsSubject.asObservable();
        this.isAdminSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('isAdmin')));
        this.isAdmin = this.isAdminSubject.asObservable();
        this.ongoingAPIRequestSubject = new BehaviorSubject<any>(null);
        this.ongoingAPIRequestSubject.subscribe((request) => {
            if (request != null) {
                if (request['status'] === 'started') {
                    this.ongoingRequestList.push(request['name']);
                } else if (request['status'] === 'ended') {
                    const index = this.ongoingRequestList.indexOf(request['name']); 
                    if (index > -1) {
                        this.ongoingRequestList.splice(index, 1);
                    }
                }         
            }            
        });
    }

    public get currentUserValue() {
        return this.currentUserSubject.value;
    }

    public get userGroupsValue() {
        return this.userGroupsSubject.value;
    }

    public get isAdminValue() {
        return this.isAdminSubject.value;
    }

    public get ongoingAPIRequests() {
        return this.ongoingRequestList;
    }

    login(username, password): Observable<any> {
        var apiUrl = this.config.getConfig("apiUrl")
        var adminGroup
        localStorage.setItem('isAdmin', JSON.stringify(false))
        return this.http.post<any>(apiUrl + `/auth/sign-in`, { username, password })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (!user['username']) {
                    user['username'] = username
                }
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                this.userGroupService.getGroups().subscribe(groups => {
                    this.usersGroupsService.getAdminGroupName().subscribe(admin => {
                        adminGroup = admin;
                        for (let i = 0; i < groups.length; i++) {
                            if (adminGroup.indexOf(groups[i]) >= 0) {
                                localStorage.setItem('isAdmin', JSON.stringify(true))
                                this.isAdminSubject.next(true);
                                break;
                            }
                        }
                    })
                    localStorage.setItem('userGroups', JSON.stringify(groups))
                    this.userGroupsSubject.next(groups);
                })
                return user;
            }));
    }

    getUserDetails(request): Observable<any> {
        var apiUrl = this.config.getConfig("apiUrl")
        localStorage.setItem('currentUser', JSON.stringify(request));
        this.currentUserSubject.next(request);
        return this.http.get<any>(apiUrl + `/auth/get-userdetails`)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                this.userGroupService.getGroups().subscribe(groups => {
                    localStorage.setItem('userGroups', JSON.stringify(groups))
                    this.userGroupsSubject.next(groups);
                })
                return user;
            }, catchError(this.handleError<any>('getUserDetails'))));
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userGroups');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('fileInboxFolderId');
        localStorage.removeItem('additionalColumns');
        localStorage.clear();
        this.currentUserSubject.next(null);
        this.userGroupsSubject.next(null);
        this.isAdminSubject.next(null)
    }

    refreshToken() {
        var apiUrl = this.config.getConfig("apiUrl")
        var req: JSON = <JSON><unknown>{
            "AuthType": "RefreshToken",
            "RefreshToken": {
                "username": this.currentUserValue.username,
                "refreshToken": this.currentUserValue.refresh_token
            }
        }
        //console.log("before getting refresh token")
        return this.http.post<any>(apiUrl + `/auth/refresh`, req)
            .pipe(map(user => {
                this.currentUserValue.token = user.token
                localStorage.setItem('currentUser', JSON.stringify(this.currentUserValue))
                this.currentUserSubject.next(this.currentUserValue)
                return this.currentUserValue;
            }));
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse) => {
            console.error('Error at the services >> %s ' + error); // log to console instead
            if (String(error).includes('.throw is not a function')) {
                this.alertService.error('ERROR: Could not connect to network. Please contact Vault team if the issue persists.');
            } else {
                this.alertService.error(String(error));
            }
            return result;
        };
    }

    getToken(body) {

        var apiUrl = this.config.getConfig("apiUrl");
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })           
          };
        return this.http.post<any>(apiUrl + `/login/getAccessToken`, body, httpOptions)

            .pipe()
    }
}